import { jsx as n } from "react/jsx-runtime";
import { Spinner as o } from "../spinner/Spinner.component.js";
import '../../assets/LoadingView.css';const r = "_container_rhvgg_1", i = {
  container: r
}, c = () => /* @__PURE__ */ n("div", { className: i.container, children: /* @__PURE__ */ n(o, {}) });
export {
  c as LoadingView
};
